import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import NoData from 'components/content/NoData';
import DateTimeOrNoData from 'features/vehicle-key-data/DateTimeOrNoData';

import SystemUsersRowStatus from '../users/SystemUsersRowStatus';

import type { User } from 'API';

import './_styles.scss';

interface UserTeamRowProps {
    user: User;
    onChange: (id: string) => void;
    checked: boolean;
}

const UserTeamRow = ({ user, checked, onChange }: UserTeamRowProps) => {
    const handleSelect = (userId: string) => {
        onChange(userId);
    };

    return (
        <tr id={user.id} className='UserTeamRow'>
            <td
                className='UserTeamRow__column'
                data-testid='user-settings-row-dropdown-icon'
                onClick={e => e.stopPropagation()}
            >
                <Checkbox className='UserTeamRow__checkbox' onChange={() => handleSelect(user.id)} checked={checked} />
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-firstName'>
                {user.firstName}
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-lastName'>
                {user.lastName}
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-email'>
                {user.email}
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-phone'>
                {user.phone ? user.phone : <NoData className='text-14' />}
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-country'>
                {user.country ? user.country : <NoData className='text-14' />}
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-city'>
                {user.city ? user.city : <NoData className='text-14' />}
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-role'>
                {user.roles?.length ? (
                    user.roles
                        .map(role => role.name)
                        .join(', ')
                        .toString()
                ) : (
                    <NoData className='text-14' />
                )}
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-status'>
                <SystemUsersRowStatus status={user.status} />
            </td>
            <td className='UserTeamRow__column' data-testid='user-settings-row-info-created'>
                <DateTimeOrNoData value={user.createdAt} />
            </td>
        </tr>
    );
};

export default UserTeamRow;
